import React from "react"
import { Box, Pagination, PaginationItem } from "@mui/material"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getPost } from "../../features/posts/postSlice"

const PaginationArticles = ({ page }) => {
  const dispatch = useDispatch()
  const { numberOfPages } = useSelector((state) => state.posts)
  React.useEffect(() => {
    if (page) dispatch(getPost(page))
  }, [page, dispatch])
  return (
    <Box padding={1}>
      <Pagination
        count={numberOfPages}
        page={Number(page) || 1}
        color="primary"
        renderItem={(item) => (
          <PaginationItem
            {...item}
            component={Link}
            to={`/posts?page=${item.page}`}
          />
        )}
      />
    </Box>
  )
}
export default PaginationArticles
